// extracted by mini-css-extract-plugin
export var body = "style-module--body--UneUa";
export var button = "style-module--button--bPZNG";
export var contact = "style-module--contact--LxNdS";
export var contactText = "style-module--contactText--nieKm";
export var heading = "style-module--heading--4d6aX";
export var item = "style-module--item--ADw5U";
export var itemHeading = "style-module--itemHeading--F6Pgz";
export var itemText = "style-module--itemText--FKkHN";
export var items = "style-module--items--kfpqv";
export var map = "style-module--map--glOh1";
export var outline = "style-module--outline--7iVyV";
export var slide = "style-module--slide--Tv1ro";
export var slideItem = "style-module--slideItem--VYlXD";